import api, { uploadApi } from './axiosConfig.js'

export const employeeApi = {
  // Add new employee
  addEmployee: (employeeData) => {
    const orgId = localStorage.getItem('org_id')
    return api.post('/employees/add/employee', employeeData, {
      headers: {
        'X-Org-ID': orgId
      },
      skipSuccessToast: true
    })
  },

  // List employees with filters
  listEmployees: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/employees/list/get-all-employees', {
      params,
      headers: {
        'X-Org-ID': orgId
      }
    })
  },

  // Get employee details
  getEmployeeDetails: (employeeId) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/employees/employee/details', {
      params: { employee_id: employeeId },
      headers: {
        'X-Org-ID': orgId
      }
    })
  },

  updateEmployee: (employeeData) => {
    const orgId = localStorage.getItem('org_id')
    const { employee_id, ...data } = employeeData
    return api.put('/employees/employee/update', data, {
      params: { employee_id },
      headers: {
        'X-Org-ID': orgId
      },
      skipSuccessToast: true
    })
  },

  // Delete employee
  deleteEmployee: (employeeId) => {
    const orgId = localStorage.getItem('org_id')
    return api.delete('/employees/employee/delete', {
      params: { employee_id: employeeId },
      headers: {
        'X-Org-ID': orgId
      }
    })
  },

  // Bulk upload employees
  bulkUpload: (formData) =>
    uploadApi.post('/employees/employees/bulk-upload', formData),

  // Get departments
  getDepartments: () =>
    api.get('/employees/departments'),

  // Get positions
  getPositions: () =>
    api.get('/employees/positions'),

  // Apply for leave
  applyLeave: (leaveData) => {
    const orgId = localStorage.getItem('org_id')
    return api.post('/leaves/create-leave', leaveData, {
      headers: {
        'X-Org-ID': orgId
      }
    })
  },
}